(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable */
import React from "react";
import less from "less";
import { getSpecialKeys, getProjectId, getCompanyId } from "jcb-token-kit";
import { JcbName } from "../utils/constant";
import useCache from "./useCache";
import favicon from "../assets/favicon.ico";
import ccFavicon from "../assets/favicon_cc.ico";
import nyFavicon from "../assets/favicon_ny.ico";
import ysFavicon from "../assets/ys_logo.ico";

var usePage = function usePage() {
  var _getSpecialKeys = getSpecialKeys(),
      _getSpecialKeys$B = _getSpecialKeys.B1,
      B1 = _getSpecialKeys$B === undefined ? {} : _getSpecialKeys$B,
      _getSpecialKeys$B2 = _getSpecialKeys.B2,
      B2 = _getSpecialKeys$B2 === undefined ? {} : _getSpecialKeys$B2;

  var _useCache = useCache(),
      projectName = _useCache.projectName;

  var updateTitle = function updateTitle(key) {
    var szCompanyid = process.env.REACT_APP_JCB_ENV === "dev" ? "20005" : "1450808";
    if (process.env.REACT_APP_TYPE === "city" || process.env.REACT_APP_TYPE === "ny") {
      console.log(JcbName, "JcbNameJcbName1");
      document.title = JcbName;
    } else if (getCompanyId() === szCompanyid) {
      document.title = "上庄镇大城管管理平台";
    } else if (getProjectId() === "1326") {
      document.title = "西城区扬尘检查项目";
    } else if (getCompanyId() === "20091") {
      document.title = "营商环境评估管理系统-成果展示";
    } else {
      var projectId = getProjectId();
      if (projectId && !localStorage.getItem("isSpecial")) {
        var pName = projectName(projectId);
        console.log(JcbName, "JcbNameJcbName2");

        document.title = pName && pName !== "null" ? pName : JcbName;
      } else {
        console.log(JcbName, "JcbNameJcbName3");

        document.title = key || B1.value || B1.default;
      }
    }
  };
  var updateFavicon = function updateFavicon(key) {
    var ele = document.getElementById("custom_favicon");
    if (!ele) {
      ele = document.querySelector('link[rel="shortcut icon"]') || document.querySelector('link[rel="icon"]');
    }
    console.log(ele, "ele");
    if (ele) {
      if (process.env.REACT_APP_TYPE === "city") {
        ele.href = ccFavicon;
      } else if (process.env.REACT_APP_TYPE === "ny") {
        ele.href = nyFavicon;
      } else if (getCompanyId() === "20091") {
        ele.href = ysFavicon;
      } else {
        if (localStorage.getItem("sign")) {
          if (B2.value) {
            ele.href = B2.value;
          }
        } else {
          ele.href = key || B2.value || favicon;
        }
      }
    }
  };
  var updateTitleAndFavicon = function updateTitleAndFavicon() {
    if (localStorage.getItem("isSpecial")) {
      updateTitle();
      updateFavicon();
    } else {
      updateTitle(JcbName);
      updateFavicon(favicon);
    }
  };
  var updateThemeColor = function updateThemeColor() {
    if (process.env.REACT_APP_TYPE === "city") {
      less.modifyVars({
        "@primary-color": "#bd192d"
      });
    } else {
      if (localStorage.getItem("themeColor") && localStorage.getItem("sign")) {
        var ele = document.getElementById("theme_less");
        if (!ele) {
          ele = document.querySelector('link[rel="stylesheet/less"]');
        }
        ele.href = "/static/color.less";
        less.modifyVars({
          "@primary-color": localStorage.getItem("themeColor")
        });
      }
    }
  };

  // 对于一些定制登录页会用到
  var getTitle = function getTitle() {
    var szCompanyid = process.env.REACT_APP_JCB_ENV === "dev" ? "20005" : "1450808";
    if (process.env.REACT_APP_TYPE === "city" || process.env.REACT_APP_TYPE === "ny") {
      return JcbName;
    } else if (getCompanyId() === szCompanyid) {
      return "上庄镇大城管管理平台";
    } else {
      var projectId = getProjectId();
      if (projectId && !localStorage.getItem("isSpecial")) {
        var pName = projectName(projectId);
        return pName && pName !== "null" ? pName : JcbName;
      }
      return document.title = B1.value || B1.default;
    }
  };

  return {
    updateTitle: updateTitle,
    updateFavicon: updateFavicon,
    updateTitleAndFavicon: updateTitleAndFavicon,
    updateThemeColor: updateThemeColor,
    getTitle: getTitle
  };
};

__signature__(usePage, "useCache{{ projectName }}", function () {
  return [useCache];
});

var _default = usePage;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(usePage, "usePage", "src/components/usePage.js");
  reactHotLoader.register(_default, "default", "src/components/usePage.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();